import { z } from "zod";
import { optionalUnlessRequired, type FieldDescriptor } from "./types.js";

const imageOptionSchema = z.object({
  value: z.string().min(1),
  label: z.string().min(1),
  assetId: z.string().optional(),
});

const configSchema = z.object({
  options: z.array(imageOptionSchema).default([]),
  allowMultiple: z.boolean().default(false),
  columns: z.number().int().min(1).max(6).default(3),
});

export const imageChoiceField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "image_choice",
  label: "Image choice",
  category: "choice",
  icon: "Images",
  configSchema,
  valueSchema: (config, isRequired) => {
    const allowed = config.options.map((option) => option.value);
    const single =
      allowed.length > 0
        ? z
            .string()
            .refine((value) => allowed.includes(value), "Select one of the available options")
        : z.string();

    if (!config.allowMultiple) return optionalUnlessRequired(single, isRequired);

    const many = z
      .array(z.string())
      .refine(
        (values) => allowed.length === 0 || values.every((value) => allowed.includes(value)),
        "One or more selections are not valid options",
      );
    return optionalUnlessRequired(
      isRequired ? many.refine((v) => v.length > 0, "Select at least one") : many,
      isRequired,
    );
  },
  defaultConfig: { options: [], allowMultiple: false, columns: 3 },
  supportsProfileBinding: false,
  defaultSearchable: true,
  renderHints: {},
};
